const langs = {
  rus: {
    calculate: {
      title: 'Рассчитать доставку',
      city: 'Город',
      from: 'Откуда',
      to: 'Куда',
      notFoundCity: 'Ничего не нашлось',
      tariffsNotFound: {
        title: 'Подходящие тарифы не найдены',
        description: 'Попробуйте ввести другие параметры',
      },
      packages: {
        weight: 'Вес, кг',
        length: 'Длина, см',
        width: 'Ширина, см',
        height: 'Высота, см',
        cm: 'см',
        kg: 'кг',
        notLessThan: 'Не менее',
        notMoreThan: 'Не более',

        withSelect: {
          length: 'Длина',
          width: 'Ширина',
          height: 'Высота',
          weight: 'Вес',
          label: 'Габариты и вес',
          approximateDimensions: 'Примерно',
          exactDimensions: 'Точные',
          upTo: 'до {0}',
          maxField: 'Максимальное значение: {max}',
          minField: 'Минимальное значение: {min}',
          cm: 'см',
          kg: 'кг',
          empty: 'Не выбрано',
          requiredField: 'Обязательное поле',
          confirm: 'Подтвердить',
          select: 'Выбрать',
        },
      },
      parcelType: {
        selectParcelType: 'Тип груза',
        parcel: 'Груз',
        documents: 'Документы',
      },
      parcelValue: {
        selectParcelValue: 'Стоимость груза',
        below: 'До {amount}{currencySymbol}',
        above: 'Более {amount}{currencySymbol}',
      },
      description:
        'После заполнения формы отправки наши сотрудники проверят фактический и объемный вес Вашего груза, подлежащего доставке. Оплата будет произведена за большее из двух значений.',
      buttonSubmit: 'Рассчитать',
    },
    selectTariff: {
      title: 'Выберите тариф',
      linkBack: 'Изменить параметры',
      changeDirection: 'Изменить направление',
      tariffsList: {
        entrypoints: {
          door: 'От двери',
          point: 'От склада',
          postamat: 'От постамата',
          terminal: 'От терминала',
        },
        endpoints: {
          door: 'До двери',
          point: 'До склада',
          postamat: 'До постамата',
          terminal: 'До терминала',
        },
      },
      days: 'дн.',
      additionalServices: {
        parameters: {
          count: 'штук',
          days: 'дней',
          meters: 'метров',
          floor: 'этажей',
          declaredCost: 'RUB',
        },
        insuranceTooltip: 'Введите ценность груза',
      },
      buttonSubmit: 'Выбрать',
      makeRequest: 'Зарегистрироваться',
      daysPlural: '0\xa0дней | {n}\xa0день | {n}\xa0дня | {n}\xa0дней',
      createOrder: 'Создать заказ',
      negotiablePriceForHeavyPackage:
        'Цена отправлений массой более {mass} кг обсуждается с оператором',
    },
    selectTariffDocuments: {
      tariffsList: {
        entrypoints: {
          door: 'От двери',
          point: 'От пункта выдачи',
          postamat: 'От постамата',
          terminal: 'От терминала',
        },
        endpoints: {
          door: 'До двери',
          point: 'До пункта выдачи',
          postamat: 'До постамата',
          terminal: 'До терминала',
        },
      },
    },
    sendRequest: {
      title: 'Контактные данные',
      description:
        'Менеджер свяжется с вами, чтобы подробнее рассказать о тарифах и условиях доставки',
      email: 'Email',
      name: 'Имя',
      TIN: 'ИНН',
      phone: 'Телефон (+7)',
      iamAgreeWith: 'Я соглашаюсь с',
      iamAgreeWithLink: 'условиями обработки персональных данных',
      recieverIs: 'Получатель',
      senderIs: 'Отправитель',
      senderIsPerson: 'Физическое лицо',
      senderIsBusiness: 'Юридическое лицо',
      customsClearance: {
        title: 'Таможенное оформление',
        options: {
          export: 'Экспортное (в стране отправителя)',
          import: 'Импортное (в стране получателя)',
          full: 'Полное (импортное + экспортное)',
          notRequired: 'Не требуется',
        },
      },
      buttonSubmit: 'Отправить',
    },
    final: {
      requestSuccess: 'Заявка отправлена!',
      description: 'Спасибо, ваша заявка успешно отправлена! Мы обработаем ее в течение 3-х дней!',
      recalculate: 'Новый расчет',
    },
    inputError: 'Некорректное значение',
  },
  eng: {
    calculate: {
      title: 'Calculate shipping cost',
      city: 'City',
      from: 'From',
      to: 'To',
      notFoundCity: 'Nothing found',
      tariffsNotFound: {
        title: 'No suitable tariffs found',
        description: 'Try entering different parameters',
      },
      packages: {
        weight: 'Weight (kg)',
        length: 'Length (cm)',
        width: 'Width (cm)',
        height: 'Height (cm)',
        notLessThan: 'Not less than',
        notMoreThan: 'Not more than',
        cm: 'cm',
        kg: 'kg',

        withSelect: {
          length: 'Length',
          width: 'Width',
          height: 'Height',
          weight: 'Weight',
          label: 'Dimensions and weight',
          approximateDimensions: 'Approximate',
          exactDimensions: 'Exact',
          upTo: 'Up to {0}',
          maxField: 'Maximum value: {max}',
          minField: 'Minimum value: {min}',
          cm: 'cm',
          kg: 'kg',
          empty: 'Not selected',
          requiredField: 'Required field',
          confirm: 'Confirm',
          select: 'Select',
        },
      },
      parcelType: {
        selectParcelType: 'Parcel type',
        parcel: 'Parcel',
        documents: 'Documents',
      },
      parcelValue: {
        selectParcelValue: 'Parcel value',
        below: 'Below {amount}{currencySymbol}',
        above: 'Above {amount}{currencySymbol}',
      },
      description:
        'Once you have filled out the form, our employees will check the actual weight and volume weight of your cargo that is subject to delivery. You will be charged for whichever one is larger.',
      buttonSubmit: 'Calculate',
    },
    selectTariff: {
      title: 'Select tariff',
      linkBack: 'Change parameters',
      tariffsList: {
        entrypoints: {
          door: 'From door',
          point: 'From warehouse',
          postamat: 'From parcel locker',
        },
        endpoints: {
          door: 'To door',
          point: 'To warehouse',
          postamat: 'To parcel locker',
        },
      },
      days: 'days',
      additionalServices: {
        parameters: {
          count: 'items',
          days: 'days',
          meters: 'meters',
          floor: 'floors',
        },
      },
      insuranceTooltip: 'Enter the value of the cargo',
      buttonSubmit: 'Select',
      negotiablePriceForHeavyPackage:
        'The price for shipments over {mass} kg is discussed with the operator',
    },
    sendRequest: {
      title: 'Contact details',
      description:
        'A manager will be in contact to tell you more about the tariffs and delivery terms and conditions',
      email: 'Email',
      name: 'First name',
      TIN: 'TIN',
      phone: 'Tel. no.',
      iamAgreeWith: 'I agree to',
      iamAgreeWithLink: 'the terms and conditions for the processing of personal data',
      recieverIs: 'Receiver',
      senderIs: 'Sender',
      senderIsPerson: 'Individual',
      senderIsBusiness: 'Legal entity',
      customsClearance: {
        title: 'Customs clearance',
        options: {
          export: 'Export (in the senders country)',
          import: 'Import (in the country of the recipient)',
          full: 'Full (import + export)',
          notRequired: 'Not required',
        },
      },
      buttonSubmit: 'Send',
    },
    final: {
      requestSuccess: 'Request sent!',
      description:
        'Thank you, your application has been successfully submitted! We will process it within 3 days!',
      recalculate: 'New calculation',
    },
    inputError: 'Invalid value',
  },
  tur: {
    calculate: {
      title: 'Gönderme ücretini hesapla',
      from: 'Nereden',
      to: 'Nereye',
      notFoundCity: 'Hiçbir şey bulunamadı',
      tariffsNotFound: {
        title: 'Uygun tarife bulunamadı',
        description: 'Diğer parametreleri girmeyi deneyin',
      },
      buttonSubmit: 'Hesaplamak',
      packages: {
        weight: 'Ağırlık, kg',
        length: 'Uzunluk, cm',
        width: 'Genişlik, cm',
        height: 'Yükseklik, cm',
        cm: 'cm',
        kg: 'kg',
        notLessThan: 'Daha az değil',
        notMoreThan: 'Daha fazla yok',

        withSelect: {
          length: 'Uzunluk',
          width: 'Genişlik',
          height: 'Yükseklik',
          weight: 'Ağırlık',
          label: 'Boyutlar ve ağırlık',
          approximateDimensions: 'Yaklaşık',
          exactDimensions: 'Tam',
          upTo: 'en fazla {0}',
          maxField: 'Maksimum değer: {maks}',
          minField: 'Minimum değer: {min}',
          cm: 'cm',
          kg: 'kg',
          empty: 'Seçilmedi',
          requiredField: 'Gerekli alan',
          confirm: 'Onayla',
          select: 'Seç',
        },
      },
      parcelType: {
        selectParcelType: 'Kargo türü',
        parcel: 'Kargo',
        documents: 'Belgeler',
      },
      parcelValue: {
        selectParcelValue: 'Kargo Değeri',
        below: '{amount}{currencySymbol} Altı',
        above: '{amount}{currencySymbol} Üstü',
      },
      description:
        'Formu doldurduktan sonra çalışanlarımız teslim edilecek kargonuzun gerçek ve hacimsel ağırlığını kontrol edeceklerdir. İki değerden yüksek olanı için ödeme yapılacaktır.',
    },
    selectTariff: {
      title: 'Tarife seçin',
      linkBack: 'Parametreyi değiştirmek',
      tariffsList: {
        entrypoints: { door: 'Kapıdan', point: 'Depodan', postamat: 'Postomattan' },
        endpoints: { door: 'Kapıya', point: 'Depoya', postamat: 'Potomata' },
      },
      days: 'gün',
      additionalServices: {
        parameters: { count: 'adet', days: 'gün', meters: 'metre', floor: 'kat' },
      },
      insuranceTooltip: 'Kargonun değerini girin',
      buttonSubmit: 'Seçmek',
      negotiablePriceForHeavyPackage:
        "{mass} kg'dan fazla ağırlıktaki gönderilerin fiyatı operatörle görüşülür",
    },
    sendRequest: {
      description:
        'Yönetici, tarifeler \nve teslimat koşulları\n hakkında daha fazla\n bilgi vermek için sizinle\n iletişime geçecektir.',
      email: 'E-posta',
      name: 'İsim',
      phone: 'Telefon numarası (+90)',
      iamAgreeWith: 'Kabul ediyorum',
      iamAgreeWithLink: 'kişisel bilgileri işleme şartlarını',
      recieverIs: 'Alıcı',
      senderIs: 'Gönderici',
      senderIsPerson: 'Gerçek kişi',
      senderIsBusiness: 'Tüzel kişi',
      tur: {
        customsClearance: {
          title: 'Gümrük İşlemleri',
          options: {
            export: 'İhracat (gönderenin ülkesinde)',
            import: 'İthalat (alıcının ülkesinde)',
            full: 'Tam (ithalat + ihracat)',
            notRequired: 'Gerekli değil',
          },
        },
      },
      buttonSubmit: 'Göndermek',
    },
    final: {
      requestSuccess: 'Başvuru gönderildi!',
      description: 'Teşekkürler, başvurunuz başarıyla gönderildi! 3 gün içinde işleme alınacaktır!',
      recalculate: 'Yeni hesaplama',
    },
    inputError: 'Geçersiz değer',
  },
};
export default langs;
